import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FiArrowLeft } from 'react-icons/fi';

export function useMobileLayout() {
  const [mobile, setMobile] = useState(() => Boolean(window.matchMedia?.('(max-width: 700px)').matches));
  useEffect(() => {
    const query = window.matchMedia?.('(max-width: 700px)');
    if (!query) return undefined;
    const update = () => setMobile(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return mobile;
}

export default function MobileContactDialog({ name, onClose, children }) {
  const dialog = useRef(null);
  useEffect(() => {
    const returnFocus = document.activeElement;
    const overflow = document.body.style.overflow;
    dialog.current.showModal();
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = overflow;
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    };
  }, []);
  return createPortal(<dialog ref={dialog} className="opp-workspace opp-connections opp-mobile-contact-dialog"
    aria-label={`Outreach for ${name}`} onCancel={(event) => { event.preventDefault(); onClose(); }}>
    <header className="opp-mobile-contact-bar"><button type="button" className="js-secondary-back" onClick={onClose}><FiArrowLeft className="js-icon--directional" aria-hidden="true" />Back to people</button></header>
    <div className="opp-mobile-contact-body">{children}</div>
  </dialog>, document.body);
}
